import React from "react";
import Vehiclecard2page from "../../pages/Vehicle/Vehiclecard2page";
import FrameVehicle1 from "../../../src/assets/images/Framevehicle1.png";
import FrameVehicle2 from "../../../src/assets/images/Framevehicle2.svg";
import FrameVehicle3 from "../../../src/assets/images/Framevehicle3.svg";
import FrameVehicle4 from "../../../src/assets/images/Framevehicle4.svg";

const ColorCardsVehicle = ({ data = [] }) => {
  const allVehicleTypes = ["M&HCV", "ILCV", "SCV & PU", "CV Passenger"];

  const colorMap = {
    "M&HCV": "#D0EBFF",
    ILCV: "#C6FFE7",
    "SCV & PU": "#D0EBFF",
    "CV Passenger": "#FFE3BA",
  };

  const logoMap = {
    "M&HCV": FrameVehicle1,
    ILCV: FrameVehicle2,
    "SCV & PU": FrameVehicle3,
    "CV Passenger": FrameVehicle4,
  };

  const dataMap = {};
  (Array.isArray(data) ? data : []).forEach((item) => {
    const normalizedKey = item.key?.replace(/_/g, " ").trim() || "";
    dataMap[normalizedKey] = item.doc_count ?? 0;
  });

  const enrichedData = allVehicleTypes.map((type) => ({
    key: type,
    doc_count: dataMap[type] ?? 0,
    color: colorMap[type] || "#FFFFFF",
    logo: logoMap[type] || null,
  }));

  return (
    <div className="flex justify-center justify-items-center gap-2">
      {enrichedData.map((item) => (
        <Vehiclecard2page
          key={item.key}
          vheading={item.key}
          color={item.color}
          logo={item.logo}
          des={item.doc_count}
        />
      ))}
    </div>
  );
};

export default ColorCardsVehicle;
